/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { PresenterResponse } from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class ExportJournalHistories<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * @description Success: CSV stream (Content-Type text/csv, Content-Disposition attachment). Errors: JSON presenter.Response via middlewareRespWriterCSV
   *
   * @tags export_journal_histories
   * @name GetExportJournalHistoriesByIdDownload
   * @summary Download export journal history CSV
   * @request GET:/export_journal_histories/{id}/download
   */
  getExportJournalHistoriesByIdDownload = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<File, PresenterResponse>({
      path: `/export_journal_histories/${id}/download`,
      method: "GET",
      format: "json",
      ...params,
    });
}
